<div id="orders" class="page-layout carded fullwidth">

    <div class="top-bg primary"></div>

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header primary" fxLayout="column" fxLayoutAlign="center center" fxLayout.gt-xs="row"
            fxLayoutGap="20px" fxLayoutAlign.gt-xs="space-between center">

            <!-- APP TITLE -->
            <div class="mat-display-1 my-0 my-sm-24 welcome-message" fxLayout="row" fxLayoutAlign="start center">
                <span [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">{{'CONTAINER_LIST'|translate}}</span>
            </div>
            <!-- / APP TITLE -->
            <div class="search-wrapper  ml-sm-32">
                <div class="search" fxFlex fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon>search</mat-icon>
                    <input #filter [(ngModel)]="filterText" placeholder="{{'SEARCH' | translate}}">
                </div>
            </div>
            <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="10px grid">
                <div fxFlex>
                    <button (click)="refresh()" mat-raised-button>
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
                <div fxFlex>
                    <button mat-raised-button (click)="multiDeleteClick()">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
                <div fxFlex>
                    <button mat-raised-button (click)="addContainer()">
                        <mat-icon>add</mat-icon>
                    </button>
                </div>
            </div>
        </div>
        <!-- / HEADER -->

        <div class="content-card my-16" style="justify-content: space-between;">

            <div class="p-20">
                <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table
                    [dataSource]="dataSource" matSort [@animateStagger]="{value:'50'}" matSortActive="c_Id"
                    matSortDirection="asc" fusePerfectScrollbar>

                    <ng-container matColumnDef="select">
                        <mat-header-cell *matHeaderCellDef>
                            <mat-checkbox color="primary" (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()"
                                [aria-label]="checkboxLabel()">
                            </mat-checkbox>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let row">
                            <mat-checkbox color="primary" (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null" [checked]="selection.isSelected(row)"
                                [aria-label]="checkboxLabel(row)">
                            </mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    
                    <ng-container matColumnDef="name">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let container">
                            {{container?.name!=null?container.name:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="deviceId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'DEVICE'|translate}} {{'ID'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let container">
                            {{container?.deviceId!=null?container.deviceId:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="neighbor">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'NEIGHBOURHOOD'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let container">
                            {{container?.neighbor!=null?container.neighbor:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="street">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'STREET'|translate}}</mat-header-cell>
                        <mat-cell *matCellDef="let container">
                            {{container?.streetDesc!=null?container.streetDesc:'---'}}
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="latitude">
                        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'SITE'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let container">
                            <a *ngIf="container.latitude" matTooltip="{{container.latitude+'/'+container.longitude}}"
                                href="javascript:void(null)" (click)="onContainerMap(container)">
                                <mat-icon>map</mat-icon>
                            </a>
                            <span *ngIf="!container.latitude">---</span>
                        </mat-cell>
                    </ng-container>

                    <ng-container matColumnDef="setting">
                        <mat-header-cell *matHeaderCellDef>{{'SETTINGS'|translate}}
                        </mat-header-cell>
                        <mat-cell *matCellDef="let container">
                            <button mat-icon-button [matMenuTriggerFor]="menu"
                                aria-label="Example icon-button with a menu">
                                <mat-icon>settings</mat-icon>
                            </button>
                            <mat-menu #menu="matMenu">
                                <button mat-menu-item
                                    (click)="container.containerType==true ? updateGarbageCenter(container):updateContainer(container)">
                                    <mat-icon>edit</mat-icon>
                                    <span>{{'UPDATE'|translate}}</span>
                                </button>
                                <button mat-menu-item (click)="deleteContainer(container)">
                                    <mat-icon>delete</mat-icon>
                                    <span>{{'DELETE'|translate}}</span>
                                </button>
                            </mat-menu>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let container; columns: displayedColumns;" class="order" matRipple>
                    </mat-row>
                </mat-table>

                <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
                </mat-paginator>
            </div>
        </div>
    </div>
    <!-- / CENTER -->
</div>